import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "manualFields", "mode", "recordedOn", "paymentLinkHint", "instantDebitHint", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const source = this.sourceTarget.value
    const stripeSource = source === "payment_link" || source === "instant_debit"

    this.manualFieldsTargets.forEach((element) => {
      element.classList.toggle("d-none", stripeSource)
    })

    if (this.hasPaymentLinkHintTarget) {
      this.paymentLinkHintTarget.classList.toggle("d-none", source !== "payment_link")
    }

    if (this.hasInstantDebitHintTarget) {
      this.instantDebitHintTarget.classList.toggle("d-none", source !== "instant_debit")
    }

    if (this.hasModeTarget) {
      this.modeTarget.required = !stripeSource
    }

    if (this.hasRecordedOnTarget) {
      this.recordedOnTarget.required = !stripeSource
    }

    if (this.hasSubmitTarget) {
      const labels = {
        payment_link: this.submitTarget.dataset.paymentLinkLabel,
        instant_debit: this.submitTarget.dataset.instantDebitLabel,
      }

      this.submitTarget.value = labels[source] || this.submitTarget.dataset.manualLabel
    }
  }
}
